import { useMemo } from 'react';
import { useFreshdeskContextState } from 'store';
import buildPermissionFlags from './permission-flags';

const useRecordPermissions = () => {
  const { getRecordPermissions } = useFreshdeskContextState();

  return useMemo(() => buildPermissionFlags(getRecordPermissions()), [getRecordPermissions]);
};

export default useRecordPermissions;
